import React from 'react';
import { Card } from 'semantic-ui-react';
import WeatherChart from './WeatherChart';
import WeatherMap from './WeatherMap';
import DeleteWeatherButton from '../containers/DeleteWeatherButton';

const WeatherListItem = ({ data }) => {
	const name = data.city.name;
	const temperatures = data.list.map(data => data.main.temp);
	const pressures = data.list.map(data => data.main.pressure);
	const humidities = data.list.map(data => data.main.humidity);
	return (
		<Card>
			<Card.Content textAlign={'center'} style={{ backgroundColor: '#f9f9f9' }}>
				<Card.Header>
					{name}
					<DeleteWeatherButton data={data} />
				</Card.Header>
			</Card.Content>
			<WeatherMap
				isMarkerShown
				googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyAq5mdSPr5OcBY6gZYoAhOceXW_BtiMy9I&libraries=geometry,drawing,places"
				loadingElement={<div style={{ height: `100%` }} />}
				containerElement={<div style={{ height: `200px` }} />}
				mapElement={<div style={{ height: `100%` }} />}
				lat={data.city.coord.lat}
				lng={data.city.coord.lon}
			/>
			<Card.Content>
				<Card.Group itemsPerRow={3}>
					<WeatherChart
						color="orange"
						data={temperatures}
						title="Temperatura"
						units="C"
						style={{ border: 'solid 1px transparent' }}
					/>
					<WeatherChart
						color="blue"
						data={humidities}
						title="Humidade"
						units="%"
					/>
					<WeatherChart
						color="red"
						data={pressures}
						title="Pressão"
						units="hPa"
					/>
				</Card.Group>
			</Card.Content>
		</Card>
	);
};

export default WeatherListItem;



// WEBPACK FOOTER //
// ./src/components/WeatherListItem.js